import { createAction, props } from '@ngrx/store';

import { FarmSettings } from '../../models/farm-settings.model';

export const loadFarmSettings = createAction('[Sustainability] Load farm-settings request');
export const loadFarmSettingsSuccess = createAction(
  '[Sustainability] Load farm-settings success',
  props<{ farmSettings: FarmSettings }>(),
);
export const loadFarmSettingsFailed = createAction(
  '[Sustainability] Load farm-settings failed',
  props<{ error: Error }>(),
);

export const upsertFarmSettings = createAction(
  '[Sustainability] Upsert farm-settings request',
  props<{ farmSettings: FarmSettings }>(),
);
export const upsertFarmSettingsSuccess = createAction(
  '[Sustainability] Upsert farm-settings success',
  props<{ farmSettings: FarmSettings }>(),
);
export const upsertFarmSettingsFailed = createAction(
  '[Sustainability] Upsert farm-settings failed',
  props<{ error: Error }>(),
);
